<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "../Button.vue";

const props = defineProps({
    formId: {
        type: String,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const formState = computed(() => store.state[props.formId]);

const tableName = computed(() => formState.value?.tableName);

const id = computed(() => formState.value?.id ?? 0);

const isSiteTree = computed(() => proxy.$route.name === 'siteTree');

const addAccess = computed(() => store.getters['user/access'](tableName.value, 'add'));

const isEnabled = computed(() => {
    const disabledTables = ['product_options', 'product_variables', 'account_settings'];

    if (disabledTables.includes(tableName.value)) {
        return false;
    }

    return addAccess.value;
});

// --- Methods ---

const onClick = () => {
    if (isSiteTree.value) {
        // The + button should always show the Add Page form, whether content or a page is selected.
        proxy.$router.push({
            name: 'siteTree',
            params: { pageOrContentId: '0' }
        });
    } else {
        proxy.$router.push({
            name: 'form',
            params: {
                component: tableName.value,
                id: 0
            }
        });
    }
};
</script>

<template>
    <Button v-if="isEnabled" :disabled="id === 0" class="rounded-0" @click.native="onClick">
        <i class="bi-plus-lg"/>
    </Button>
</template>